/* eslint-disable react/prop-types */
import React from 'react'
import { useLocation, Route, Redirect } from 'react-router-dom'
import AuthService from '../services/AuthService'

const auth = new AuthService()

function PrivateRoute ({ children, ...restRouteProps }) {
  const location = useLocation()

  // const loggedIn = isLocal || auth.isAuthenticated()
  const loggedIn = auth.loggedIn()

  return loggedIn ? (
    <Route {...restRouteProps}>{children}</Route>
  ) : (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: location }
      }}
    />
  )
}

export default PrivateRoute